import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import { requisitionLink } from "../../../utils/helpers";
import RecievePurchaseGRNModal from "../../modals/RecievePurchaseGRNModal";
import StockAndIssueModal from "../../modals/StockAndIssue";
import DotsVerticalIcon from "mdi-react/DotsVerticalIcon";
import { PrintIcon, RecieptIcon } from "../../Icons";
import EyeOutlineIcon from "mdi-react/EyeOutlineIcon";
import CubeOutlineIcon from "mdi-react/CubeOutlineIcon";
import { useAuth } from "../../../hooks/useAuth";

const AfterGRNRaisedDropdown = ({ refetch = () => {}, invoiceNumber }) => {
  const { backendUrl } = useAuth();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [purchaseToHandle, setPurchaseToHandle] = useState(null);
  const [stockAndIssue, setStockAndIssue] = useState(null);

  const fetchPurchaseData = async () => {
    const response = await fetch(
      `${backendUrl}/api/invexcloud/purchase-request-grn?invoiceNumber=${invoiceNumber}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "include",
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message);
    }

    const { data } = await response.json();
    return data?.purchaseGrns[0] || null;
  };

  const { data: purchaseData, isLoading, error } = useQuery({
    queryKey: ["purchase-grn", invoiceNumber],
    queryFn: fetchPurchaseData,
    enabled: isDropdownOpen,
    staleTime: 0,
  });

  const handleDropdownToggle = isOpen => {
    setIsDropdownOpen(isOpen);
  };

  return (
    <>
      <Dropdown onToggle={handleDropdownToggle}>
        <Dropdown.Toggle
          variant=""
          className="bg-white border-1"
          bsPrefix="print more"
        >
          <DotsVerticalIcon />
        </Dropdown.Toggle>

        <Dropdown.Menu
          popperConfig={{
            strategy: "fixed",
          }}
          renderOnMount
          className="dropdown-with-icons"
        >
          {isLoading ? (
            <Dropdown.Item disabled>Loading...</Dropdown.Item>
          ) : error || !purchaseData ? (
            <Dropdown.Item disabled>No data available</Dropdown.Item>
          ) : (
            <>
              <Dropdown.Item
                as="a"
                href={`${backendUrl}/api/invexcloud/pdf/grn/${invoiceNumber}`}
                target="_blank"
              >
                <PrintIcon />
                Print GRN
              </Dropdown.Item>

              {purchaseData.Status !== "CONFIRMED" && (
                <>
                  <Dropdown.Item
                    onClick={() => setPurchaseToHandle(purchaseData)}
                  >
                    <CubeOutlineIcon /> Add to Stock (CONFIRM)
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => setStockAndIssue(purchaseData)}>
                    <CubeOutlineIcon /> Add to Stock and Issue (CONFIRM)
                  </Dropdown.Item>
                </>
              )}
            </>
          )}
        </Dropdown.Menu>
      </Dropdown>

      {purchaseToHandle && (
        <RecievePurchaseGRNModal
          show={purchaseToHandle}
          InvoiceNo={invoiceNumber}
          setShow={setPurchaseToHandle}
          refetch={refetch}
        />
      )}

      {stockAndIssue && (
        <StockAndIssueModal
          show={stockAndIssue}
          InvoiceNo={invoiceNumber}
          setShow={setStockAndIssue}
          refetch={refetch}
        />
      )}
    </>
  );
};

export default AfterGRNRaisedDropdown;
